import parseNumber from './parseNumber';

export default function parseNumberNullable(val: unknown): number | null {
    if (val === null || val === undefined) return null;
    else return parseNumber(val);
}
